<template>
  <div class="footerOut">
    <div class="inner">
      <div class="left">
        <div class="item">
          <div class="title">单细胞在线分析</div>
          <router-link to="/tooldetail?id=135" target="_blank">
            Cell Ranger细胞定量分析
          </router-link>
          <router-link to="/tooldetail?id=446" target="_blank">
            单细胞转录组质控及分群
          </router-link>
          <router-link to="/tooldetail?id=348" target="_blank">
            细胞类型注释
          </router-link>
          <router-link to="/tooldetail?id=373" target="_blank">
            细胞通讯分析
          </router-link>
          <router-link to="/tooldetail?id=461" target="_blank">
            TCR免疫组库分析
          </router-link>
          <router-link to="/tooldetail?id=459" target="_blank">
            细胞群提取及亚群分群
          </router-link>
        </div>
        <div class="item">
          <div class="title">转录组在线分析</div>
          <router-link to="/tooldetail?id=421" target="_blank">
            转录组质控和定量分析
          </router-link>
          <router-link to="/tooldetail?id=424" target="_blank">
            转录组基因表达差异分析
          </router-link>
          <router-link to="/tooldetail?id=139" target="_blank">
            加权基因共表达网络分析
          </router-link>
          <router-link to="/tooldetail?id=418" target="_blank">
            KEGG富集分析
          </router-link>
          <router-link to="/tooldetail?id=463" target="_blank">
            Go富集分析
          </router-link>
          <router-link to="/tooldetail?id=464" target="_blank">
            GSEA分析
          </router-link>
        </div>
        <div class="item">
          <div class="title">孟德尔随机化在线分析</div>
          <router-link to="/tooldetail?id=380" target="_blank">
            GWAS数据提取
          </router-link>
          <router-link to="/tooldetail?id=117" target="_blank">
            孟德尔随机化
          </router-link>
          <router-link to="/tooldetail?id=116" target="_blank">
            孟德尔随机化之敏感性分析
          </router-link>
        </div>
        <div class="item">
          <div class="title">联系我们</div>
          <div>{{FOOT_COMPANY.ADDRESS}}</div>
          <div>Tel：{{FOOT_COMPANY.TELEPHONE}}</div>
          <div>E-mail：{{FOOT_COMPANY.EMAIL}}</div>
          <div>QQ：{{FOOT_COMPANY.QQ}}</div>
        </div>
      </div>
      <div class="right">
        <div class="wechat-wrapper">
          <div class="wechat-trigger">
            <img src="../assets/images/WeChat.png" />
            <div>翰佰尔公众号</div>
          </div>
          <!-- 悬浮弹窗 -->
          <div class="qrcode-popup">
            <img src="../assets/images/qrcode.png" />
            <div class="tip">扫描二维码关注</div>
          </div>
        </div>      
        <div @click="openUrl('https://space.bilibili.com/3546630311643441')">
          <img src="../assets/images/bilbil.png" />
          <div>Bilibili</div>
        </div>
        <div @click="openUrl('https://www.zhihu.com/people/6-37-29-70/posts')">
          <img src="../assets/images/zhihu.png" />
          <div>知乎</div>
        </div>
      </div>     
    </div>
    <div class="bottom" v-html="footInfo"></div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import { FOOT_COMPANY } from '../../public/config';

export default defineComponent({
  name: "FooterLayer",
  props: [""],
  setup() {
    let footInfo = ref();

    onMounted(()=>{
      const url = window.location.href;
      // 通过正则表达式解析出域名
      let domainReg = new RegExp("^https?://([^:/]+)", 'i');
      let matches = url.match(domainReg);
      let domain = matches && matches[1];
      if(domain){
        domain = domain.toLowerCase();
        if(domain.indexOf('cn') > -1){ //如果访问是cn结尾的域名
          footInfo.value = FOOT_COMPANY.COPYRIGHT_CN;
        }else if(domain.indexOf('com') > -1){ //如果访问是com结尾的域名
          footInfo.value = FOOT_COMPANY.COPYRIGHT_COM;
        }else{
          footInfo.value = FOOT_COMPANY.COPYRIGHT_COM;
        }
      }
    });

    const openUrl = (url) => {
      window.open(url);
    }

    return {
      FOOT_COMPANY,
      footInfo,
      openUrl
    };
  }
});
</script>

<style lang="less" scoped>
.footerOut{
  font-size: 0.95rem;
  padding: 20px 0;
  box-sizing: border-box;
  width: 100%;
  min-width: 1410px;
  background-color: #414141;
  .inner {
    width: 1200px;
    margin: 0 auto;
    color: #A0A0A0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
      display: flex;
      width: 100%;
      .item{
        width: 23%;
        line-height: 30px;        
        margin-right: 2%;
        a{
          display: block;
          color: #A0A0A0;
          font-size: 1.1rem;
          &:hover{
            color: #d6d6d6;
          }
        }
        .title{ 
          font-size: 1.2rem;
          color: #fff;
          font-weight: bold;
          margin-bottom: 10px;
        }
      }
      .item:last-child{
        margin-right: 0 !important;
      }
    } 
    .right{
      display: flex;
      &>div{
        cursor: pointer;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100px;
        &:hover{
          transform: scale(1.1);
        }
        &>img{
          width: 50px;
          height: 50px;
          margin-bottom: 10px;
        }
      }
      &>div:first-child:hover{
        cursor: none;
      }
    }   
  }  
  .bottom{ 
    width: 1200px;
    margin: 0 auto;
    border-top: 1px solid #737373;
    padding-top: 20px;
    color: #ADADAD;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-top: 15px;
    :deep(a){
      color: #ADADAD;
      &:hover{
        color: #fff;
      }
    }
  }
}
.wechat-wrapper {
  position: relative;
  display: inline-block;
}
.wechat-trigger {
  cursor: default;
  text-align: center;
  &>img { 
    margin-bottom: 5px;
  }
}
/* 默认隐藏弹窗 */
.qrcode-popup {
  position: absolute;
  bottom: 100%;  /* 在元素上方显示 */
  left: 50%;
  transform: translateX(-50%) scale(0.8);
  margin-bottom: 10px;
  padding: 10px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 100;
  &>img {
    width: 120px;
    height: 120px;
    display: block;
  }
  .tip {
    font-size: 12px;
    color: #666;
    margin-top: 5px;
    white-space: nowrap;
    text-align: center;
  }
} 
/* 悬停显示 */
.wechat-wrapper:hover .qrcode-popup {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) scale(1);
}
/* 小三角 */
.qrcode-popup::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: white;
}
</style>